<template>
  <div class="col-sm-12">
    <Transition name="fade">
      <div v-if="itemsList.length > 0" class="col-sm-12 list-content result-table">
          <vue3-datatable
              ref="resultTable"
              :rows="itemsList"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="showDocument"
          >
              <template #added_time="row">
                  {{ row.value.added_time ? toLocalTime(row.value.added_time) : '' }}
              </template>
          </vue3-datatable>
        <div
          v-if="fetchFinished && items.length === 0"
          class="text-center my-2"
        >
          {{ $t('common.no_results') }}
        </div>
        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'GeneralGuidesList',
    mixins: [restApi, timeUtils],
    components: {Vue3Datatable},
    props: {
        items: {
            type: Array,
            default: null,
        },
        user: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        fetchFinished: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fields: [
                { field: 'name', title: this.$t('general_guides.document_title'), sort: true, headerClass: 'routa-table-header'},
                { field: 'category', title: this.$t('general_guides.category'), sort: true, headerClass: 'routa-table-header'},
                { field: 'description', title: this.$t('common.description'), sort: true, headerClass: 'routa-table-header'},
                { field: 'added_time', title: this.$t('general_guides.time_added'), sort: true, headerClass: 'routa-table-header'},
                { field: 'added_by', title: this.$t('general_guides.added_by'), sort: true, headerClass: 'routa-table-header'},
                { field: 'company', title: this.$t('common.company'), sort: true, headerClass: 'routa-table-header'},
            ],
            itemsList: []
        }
    },
    watch: {
        items()  {
            let temp = []
            this.itemsList = []
            this.items.forEach(item =>
                temp.push({
                    ...item,
                    'id': item.id,
                    'name': item.name,
                    'category': item.category?.name,
                    'description': item.description,
                    'added_time': item.added_time,
                    'company': item.company.name,
                    'added_by': item ? item.added_by.first_name + ' ' + item.added_by.last_name : '',
                })
            )
            this.$nextTick(() => this.itemsList = temp )
        }
    },
    mounted() {
        this.itemsList = this.items
    },

    methods : {
        showDocument: function (result) {
            let p = this.items.find(item => item.id === result.id)
            if (p) {
                this.$emit('edit', p)
            }
        },

        getAddedByName(added_by) {
            return added_by.last_name + ', ' + added_by.first_name
        },

        sortCompare(aRow, bRow, key) {
            if (key === 'company') {
                const a = aRow['company']
                const b = bRow['company']
                return a.name < b.name ? -1 : b.name < a.name ? 1 : 0
            }
            if (key === 'added_by') {
                const a = this.getAddedByName(aRow['added_by'])
                const b = this.getAddedByName(bRow['added_by'])
                return a < b ? -1 : b < a ? 1 : 0
            }
            return undefined;
        }
    }
}
</script>
